import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SwatchComponentDef } from '@df/catalog-ui/product/swatch/swatch.component.def';
import { ImageModule } from '@df/module-image/image.module';
/**
 * You can pass either option or value + attributeCode pair
 *
 * <swatch [option]="option"></swatch>
 * <swatch [value]="colorValue" attributeCode="color"></swatch>
 */
@Component({
    selector: 'swatch',
    templateUrl: './swatch.html',
    styleUrls: ['./swatch.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ImageModule]
})
export class SwatchComponent extends SwatchComponentDef {
    @Input()
    @HostBinding('class.disabled')
    disabled?: boolean;
    @Input()
    isBig = false;
    @Input()
    isHuge = false;
    @Input()
    isRound = false;
    @Input()
    image?: string;
    override getType(): 'image' | 'background' | 'checkbox' {
        if (this.image || !this.option) {
            return 'image';
        }
        return super.getType();
    }
}
